import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./SmoothScroll";

const NAV = [
  { label: "Leistungen", id: "leistungen" },
  { label: "Arbeiten", id: "arbeiten" },
  { label: "Prozess", id: "prozess" },
  { label: "Kontakt", id: "kontakt" },
];

export default function Footer() {
  const loc = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    if (loc.pathname === "/") scrollToId(id);
    else navigate("/", { state: { scrollTo: id } });
  };

  return (
    <footer className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-[1360px] px-5 py-16 md:px-10 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <span className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-full bg-white shadow-lg md:h-28 md:w-28">
                <img src="/logo.webp" alt="IYM – I'm Your Man Logo" className="h-24 w-24 object-contain md:h-28 md:w-28" />
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-[#b3ada2]">
              Im Your Man. Deine Agentur für Webdesign, Entwicklung und Google Ads. Digitale Auftritte,
              die verkaufen.
            </p>
            <a
              href="mailto:info.iym24@gmail.com"
              data-testid="footer-email"
              className="mt-6 inline-block font-display text-lg text-white underline decoration-[#7c86ff] decoration-2 underline-offset-4"
            >
              info.iym24@gmail.com
            </a>
          </div>

          <div className="md:col-span-5">
            <p className="mb-4 font-mono text-xs uppercase tracking-wider text-[#8a857b]">Navigation</p>
            <div className="grid grid-cols-2 gap-3">
              {NAV.map((n) => (
                <button
                  key={n.id}
                  onClick={() => go(n.id)}
                  data-testid={`footer-nav-${n.id}`}
                  className="text-left font-display text-lg text-[#e7e2d8] transition-colors hover:text-white"
                >
                  {n.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-sm text-[#8a857b] md:flex-row">
          <span>© {new Date().getFullYear()} IYM. Im Your Man. Alle Rechte vorbehalten.</span>
          <div className="flex gap-6">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white">
              Impressum
            </Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
